import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Dil kaynaklarını içe aktarıyoruz
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';

// Kullanılabilir diller
export const languages = {
  en: { nativeName: 'English', flag: '🇬🇧' },
  tr: { nativeName: 'Türkçe', flag: '🇹🇷' },
};

// Çeviri kaynakları
const resources = {
  en: {
    translation: translationEN
  },
  tr: {
    translation: translationTR
  }
};

i18n
  // i18n'i react-i18next ile entegre et
  .use(initReactI18next)
  // Tarayıcı dilini otomatik algıla
  .use(LanguageDetector)
  // i18n başlatma
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'en', // varsayılan dili "en" (İngilizce) olarak ayarla
    fallbackLng: 'en', // Çeviri bulunamazsa kullanılacak yedek dil
    
    interpolation: {
      escapeValue: false, // React zaten XSS koruması yapıyor
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'], // dil seçimini localStorage'da sakla
    },
    react: {
      useSuspense: false, // Suspense'i devre dışı bırak (stabilite için)
      bindI18n: 'languageChanged loaded', // ÖNEMLI: Dil değiştiğinde ve yüklendiğinde render et
      bindI18nStore: 'added removed', 
      transEmptyNodeValue: '',
    },
  });

export default i18n;